import React, { useState } from "react";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className=" flex flex-col md:flex-row justify-between items-center w-full h-auto pt-5 px-4 md:px-20">
      <div className="flex justify-end items-center w-full md:w-auto mb-4 md:mb-0 px-4">
        <button
          className="md:hidden text-black focus:outline-none"
          onClick={toggleMenu}
        >
          <svg
            className="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            ></path>
          </svg>
        </button>
      </div>
      <ul
        className={`w-full hidden border-[2px] border-white rounded-lg p-4 md:flex items-center justify-between bg-[#375ede]`}
      >
        <a href="/">
          <li className="text-white text-[24px] mr-10 cursor-pointer">
            Startseite
          </li>
        </a>
        <a href="/about">
          <li className="text-white text-[24px] mr-10 cursor-pointer">
            Über uns
          </li>
        </a>
        <a href="services">
          <li className="text-white text-[24px] mr-10 cursor-pointer">
            Unsere Dienstleistungen
          </li>
        </a>
        <a href="contact">
          <li className="text-white text-[24px] cursor-pointer">
            Kontaktiere uns
          </li>
        </a>
      </ul>
      {isMenuOpen && (
        <div className="md:hidden fixed inset-0 z-50 bg-[#375edee3] bg-opacity-90 flex justify-center items-center">
          <ul className="flex flex-col space-y-4 text-white text-2xl">
            <a href="/" onClick={toggleMenu}>
              <li className="cursor-pointer hover:text-gray-300">Startseite</li>
            </a>

            <a href="/about" onClick={toggleMenu}>
              <li className="cursor-pointer hover:text-gray-300">Über uns</li>
            </a>

            <a href="services" onClick={toggleMenu}>
              <li className="cursor-pointer hover:text-gray-300">
                Unsere Dienstleistungen
              </li>
            </a>
            <a href="contact" onClick={toggleMenu}>
              <li className="cursor-pointer hover:text-gray-300">
                Kontaktiere uns
              </li>
            </a>
          </ul>
          <button
            className="absolute top-12 right-5 text-white"
            onClick={toggleMenu}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              ></path>
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};

export default Navbar;
